import { render } from "./WarningAutoCallDialog.vue?vue&type=template&id=0d158530&scoped=true"
import script from "./WarningAutoCallDialog.vue?vue&type=script&lang=js"
export * from "./WarningAutoCallDialog.vue?vue&type=script&lang=js"

import "./WarningAutoCallDialog.vue?vue&type=style&index=0&id=0d158530&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d158530"]])

export default __exports__